import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

/**
 * SatisfactionWidget — valutazione con 3 emoji (0=😞, 50=😐, 100=😄).
 * Riutilizzato in `PracticeDetail` (bacheca operatore) e in
 * `PracticeQuickView` (modal marketplace PRO).
 */
export function SatisfactionWidget({ practiceId, existingScore, onRated }) {
  const [saving, setSaving] = useState(false);
  const [score, setScore] = useState(existingScore ?? null);
  const options = [
    { value: 0,   emoji: "😞", label: "Insoddisfatto", ring: "hover:ring-red-300 data-[sel=true]:ring-red-500 data-[sel=true]:bg-red-50" },
    { value: 50,  emoji: "😐", label: "Neutro",       ring: "hover:ring-amber-300 data-[sel=true]:ring-amber-500 data-[sel=true]:bg-amber-50" },
    { value: 100, emoji: "😄", label: "Soddisfatto",  ring: "hover:ring-emerald-300 data-[sel=true]:ring-emerald-500 data-[sel=true]:bg-emerald-50" },
  ];

  const submit = async (v) => {
    if (score !== null || saving) return;
    setSaving(true);
    try {
      await api.post(`/practices/${practiceId}/rate`, { score: v });
      setScore(v);
      toast.success("Grazie per il tuo feedback!");
      onRated && onRated(v);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore durante il salvataggio");
    } finally {
      setSaving(false);
    }
  };

  const alreadyRated = score !== null;
  return (
    <div className="kpi-card" data-testid="satisfaction-widget">
      <div className="flex items-start gap-4">
        <div className="hidden sm:flex h-11 w-11 rounded-full bg-purple-100 items-center justify-center shrink-0">
          <span className="text-2xl">✨</span>
        </div>
        <div className="flex-1">
          <div className="label-eyebrow text-[10px]">Feedback</div>
          <h3 className="font-display text-lg font-bold tracking-tight mt-1">
            {alreadyRated ? "Grazie per la tua valutazione!" : "Come è andato il servizio?"}
          </h3>
          <p className="text-xs text-muted-foreground mt-1">
            {alreadyRated
              ? "Il tuo giudizio ci aiuta a migliorare la qualità dei servizi Housetag."
              : "Il tuo feedback rapido ci aiuta a mantenere alta la qualità."}
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            {options.map((o) => (
              <button
                key={o.value}
                type="button"
                onClick={() => submit(o.value)}
                disabled={alreadyRated || saving}
                data-sel={score === o.value}
                className={`flex flex-col items-center gap-1 px-4 py-3 rounded-xl border-2 border-slate-200 bg-white ring-2 ring-transparent transition-all ${o.ring} ${alreadyRated && score !== o.value ? "opacity-40" : ""} disabled:cursor-not-allowed`}
                data-testid={`rate-emoji-${o.value}`}
              >
                <span className="text-3xl leading-none">{o.emoji}</span>
                <span className="text-[11px] font-semibold text-slate-700">{o.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SatisfactionWidget;
